export enum ChargingSessionGraphViewType {
  HOUR = "HOUR",
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
}
